import React from "react";
import CancellationList from "./components/CancellationList";
import CancelSubComponents from "./components";
import ContinueToCancel from "./components/ContinueToCancel";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "../../../CommonComponents/AssetsHelper";
import { Button } from "react-bootstrap";

var dataJson = [
    {
        type: 1,
        interHeading: 'Found a better alternative', text: 'Did you find a product with better features or price than ours?',
        icon: <FontAwesomeIcon type={'solid'} icon={'right-left'} iconClass={'fa-duotone'} />
    },
    {
        type: 2,
        interHeading: 'Too expensive', text: 'Did the price we offer not match your expectations?', 
        icon: <FontAwesomeIcon type={'regular'} icon={'circle-dollar'} iconClass={'fa-duotone'} />
    },
    {
        type: 3,
        interHeading: 'Technical issues', text: 'Finding it hard to avoid technical glitches?', 
        icon: <FontAwesomeIcon type={'solid'} icon={'headset'} iconClass={'fa-duotone'} />
    },
    {
        type: 4,
        interHeading: 'Hard to setup and use', text: 'Do you need any help with setting up the widget to get the most out of it?', 
        icon: <FontAwesomeIcon type={'regular'} icon={'circle-question'} iconClass={'fa-duotone'} />
    },
    {
        type: 5,
        interHeading: 'Others (please specify)', text: "Is there anything else that's bothering you?", 
        icon: <FontAwesomeIcon type={'regular'} icon={'circle-ellipsis'} iconClass={'fa-duotone'} />
    }
]

class Cancellation extends React.Component {

    constructor(props) {
        super(props);
        this.state ={ 
            pageData: {}, 
            pageStatus: 0, 
            acceptOfferData: {},
            cancellationType: null
        };
    }


    handleStatusChange = (data, pageType) => {
        this.setState({ pageData: data, pageStatus: pageType, cancellationType: null });
    };

    updateCancellationType = (type)=>{
        this.setState({ cancellationType: type });
    }

    acceptOfferSubscription = (value) => { this.setState({ acceptOfferData: value }) }
    render() {
        const { pageData, pageStatus, acceptOfferData, cancellationType } = this.state;
        const { handleParentStatus, cancellationDetails } = this.props;

        const { planId, product_id } = (cancellationDetails && Object.keys(cancellationDetails).length > 0) ? cancellationDetails.productCancellation : { planId: 0, product_id: 6 };
        const planDetails = {planId, product_id};
        
        return (
            <div className="d-flex flex-column-fluid content-wrap no_subheader cancellation-main bg-white overflow-auto">
                <Button variant="" className="btn-square close-modal" onClick={() => handleParentStatus(false)}>
                    <FontAwesomeIcon type={'regular'} icon={'xmark'} iconClass={''} />
                </Button>
                <div className="container">
                    <div className={`small_container_main pb-0 ${cancellationType != null && 'd-flex align-items-center justify-content-center h-100 w-100'} `}>
                        <div className="p-3">
                            <div className="my-3">
                                {cancellationType ?
                                    <ContinueToCancel pageStatus={cancellationType} acceptOfferData={acceptOfferData} handleParentStatus={handleParentStatus} />
                                    :
                                    (pageData && Object.keys(pageData).length > 0) ? 
                                      <CancelSubComponents pageData={pageData} handleStatusChange={this.handleStatusChange} updateCancellationType={this.updateCancellationType} acceptOfferSub={this.acceptOfferSubscription} planDetails={planDetails}/> : 
                                    <CancellationList handleStatusChange={this.handleStatusChange} data={dataJson} planId={planId} />
                                }
                            </div>
                            {
                                pageStatus == 0 &&
                                <div className="cancellation-footer bg-white">
                                     <div className="small_container text-end">
                                   <Button variant="primary" onClick={() => handleParentStatus(false) }>Keep my subscription</Button>
                                     </div>
                                </div>
                            }
                        </div>
                    </div>
                    
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        cancellationDetails: state.userAccountData,
    }
}

export default connect(mapStateToProps)(Cancellation);